export const snakeToDisplayCases = (val: string) => {
  const formatted = val.toLocaleLowerCase().split("_");

  return formatted
    .map(word => {
      const first = word.charAt(0).toLocaleUpperCase();
      const rest = word.substring(1);
      return first + rest;
    })
    .join(" ");
};

export const camelToKebabCase = (value: string) =>
  value
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();

/**
 * A simple helper function that returns the input string or enDash if not truthy.
 *
 * @returns `input` value or `–`;
 * @param value string
 * @example displayValue(account?.id)
 */
export const displayValue = (value: string | undefined | null) => {
  if (!value) {
    return " ";
  }
  return value;
};
